export { BackgroundColor, LogoSize } from './logo.component';
